// FILE 17: src/components/ui/SectionHeader.js
import React from 'react';
import './SectionHeader.css';

/**
 * @param {string} title
 * @param {string} [subtitle]
 * @param {'left'|'center'} [align]
 */
export default function SectionHeader({ title, subtitle, align = 'center' }) {
  return (
    <div className={`section-header section-header--${align}`}>
      <h2 className="section-header__title">{title}</h2>
      <div className="section-header__accent" aria-hidden="true" />
      {subtitle && <p className="section-header__subtitle">{subtitle}</p>}
    </div>
  );
}
